<template>
  <main>
    <router-view />
  </main>
</template>

<script>
import * as Sentry from '@sentry/browser';

export default {
  created() {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    // ukit/quiz-wizard
    Sentry.init({
      dsn: 'https://bba72599d78d47ababb4f5e1970d9b5a@sentry.io/1544913',
      environment: window.location.hostname,
    });
  },
};
</script>

<style src="./app.css"></style>
